<template>
  <v-layout>
    <v-container>
      <v-flex xs12 sm12  lg12 >
        <!--FORM EDIT-->
        <form @submit.prevent="update" @keydown="data.onKeydown($event)" v-show="dialogEdit">
          <v-flex  class="text-center">
            <v-btn fab small center dark color="indigo">
              <v-icon @click="dialog=false, dialogEdit=false" dark>reply</v-icon>
            </v-btn>
          </v-flex>
          <v-card-title primary-title>
            <h3 class="headline mb-0">Crear agenda cita: {{quoteData.description}}</h3>
          </v-card-title>
          <v-card-text>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="data.dateStart"
                  label="Fecha inicial *"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker @change="validateData" v-model="data.dateStart" @input="validateData(), menu = false"></v-date-picker>
            </v-menu>
            <v-menu
              ref="menu4"
              v-model="menu4"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="data.timeStart"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="data.timeStart"
                  label="Hora inicial *"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menu4"
                v-model="data.timeStart"
                full-width
                @input="validateData"
                @click:minute="$refs.menu4.save(data.timeStart)"
              ></v-time-picker>
            </v-menu>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="data.dateEnd"
                  label="Fecha Final *"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="data.dateEnd"  @change="validateData"  @input="menu2 = false, validateData()">
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="menu"
              v-model="menu3"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="data.timeEnd"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="data.timeEnd"
                  label="Hora final *"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                @input="validateData()"
                v-if="menu3"
                v-model="data.timeEnd"
                full-width
                @click:minute="$refs.menu.save(data.timeEnd)"
              ></v-time-picker>
            </v-menu>
          </v-card-text>
          <div class="error" v-show="errorSchedule" sm-12>{{validated.message}}</div>
          <v-card-actions>
            <submit-button color="blue darken-1" flat :form="data" label="Actualizar agenda"></submit-button>
          </v-card-actions>
          <br>
          <hr>
        </form>
      </v-flex>

      <v-flex xs12 sm12  lg12  v-show="dialog">
        <v-card>
          <progress-bar :show="data.busy"></progress-bar>
          <form @submit.prevent="create" @keydown="data.onKeydown($event)">
            <v-flex  class="text-center">
              <v-btn fab small center dark color="indigo">
                <v-icon @click="PrevCanlendar" dark>reply</v-icon>
              </v-btn>
            </v-flex>
            <v-card-title primary-title>
              <h3 class="headline mb-0">Crear agenda cita: {{quoteData.description}}</h3>
            </v-card-title>
            <v-card-text>
              <date-picker
                locale="es"
                :form="data"
                label="Fecha inicio *"
                :v-errors="errors"
                :value.sync="data.dateStart"
                name="dateStart"
                v-validate="'required'"
              ></date-picker>

              <time-picker
                :form="data"
                label="Hora inicio *"
                :v-errors="errors"
                :value.sync="data.timeStart"
                name="timeStart"
                v-validate="'required'"
              ></time-picker>

              <date-picker
                locale="es"
                :form="data"
                label="Fecha fin *"
                :v-errors="errors"
                :value.sync="data.dateEnd"
                name="dateEnd"
                v-validate="'required'"
              ></date-picker>

              <time-picker
                :form="data"
                label="Hora fin *"
                :v-errors="errors"
                :value.sync="data.timeEnd"
                name="timeEnd"
                v-validate="'required'"
              ></time-picker>
            </v-card-text>
            <div class="error" v-show="errorSchedule" sm-12>{{validated.message}}</div>
            <v-card-actions>
              <submit-button color="blue darken-1" flat :form="data" label="Crear agenda"></submit-button>
            </v-card-actions>
            <br>
            <hr>
          </form>
          <v-card-title><b>Subida masiva de citas</b></v-card-title>
          <form enctype="multipart/form-data">
            <input id="upload" type=file @input="upFile"  name="files[]">
            <v-btn class="v-btn blue" v-if="dataExcel.length >0" @click="proccess">Procesar</v-btn>

          </form>
          <v-flex xs12 sm12>
            <div>
              <v-card>
                <v-card-title>
                  Citas
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="dataExcel"
                  :search="search"
                  :loading="loadingTable"
                >

                  <template slot="items" slot-scope="props"
                  >
                    <td class="text-xs-center">{{ props.item.fecha_inicial}}</td>
                    <td class="text-xs-center">{{ props.item.hora_inicial }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_final }}</td>
                    <td class="text-xs-center">{{ props.item.hora_final }}</td>
                    <td class="text-xs-center blue--text"  v-if="props.item.status==0">Por procesar</td>
                    <td class="text-xs-center red--text" v-else-if="props.item.status==1">Existe un registro igual</td>
                    <td class="text-xs-center green--text" v-else>Procesado</td>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                  </v-alert>
                </v-data-table>
              </v-card>
            </div>
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12  v-show="dialog==false && dialogEdit==false">
        <h3 class="headline mb-0">Cita: {{quoteData.description}}</h3>
        <v-flex  class="text-center">
          <v-btn fab small center dark color="indigo">
            <v-icon @click="dialog=true, errorSchedule=false, dataExcel=[]" dark>add</v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          sm12
          lg3
          class="pa-3 mb-3 feature-pane"
        >
          <v-btn
            fab
            outline
            small
            absolute
            left
            color="primary"
            @click="nextPrev(-1)"
          >
            <v-icon dark>
              keyboard_arrow_left
            </v-icon>
          </v-btn>

          <v-btn
            fab
            outline
            small
            absolute
            right
            color="primary"
            @click="nextPrev(1)"
          >
            <v-icon
              dark
            >
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-flex>
        <v-layout mb-3 justify-center row>
          <v-flex pb-4 xs2>
            <span class="headline primary--text">{{ month_to_show }}</span>
          </v-flex>
        </v-layout>
        <v-sheet height="auto">
          <v-calendar
            :now="start"
            :end="start"
            :start="start"
            ref="calendar"
            color="primary"
          >
            <template v-slot:day="{ date }">
              <template v-for="event in eventsMap[date]">
                <v-menu
                  :key="event.title"
                  v-model="event.open"
                  full-width
                  offset-x
                >
                  <template v-slot:activator="{ on }">
                    <div
                      v-if="!event.time"
                      v-ripple
                      :class="{'my-event': event.status==0, 'my-event-process': event.status==1, 'my-event-success': event.status==2}"
                      v-on="on"
                      v-html="event.title"
                    ></div>
                  </template>
                  <v-card
                    color="grey lighten-4"
                    min-width="350px"
                    flat
                  >
                    <v-toolbar
                      color="primary"
                      dark
                    >
                      <v-toolbar-title v-html="event.title"></v-toolbar-title>
                    </v-toolbar>
                    <v-card-title primary-title>
                      <span v-html="event.details"></span>
                    </v-card-title>
                    <v-card-text>
                      <span v-html="date_init + event.start"></span>
                      <br>
                      <span v-html="date_end + event.end"></span>
                      <br>
                      <span v-html="taker + (event.taker != null ? event.taker: '')"></span>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        v-show="event.status==0"
                        @click="getEdit(event)"
                        flat
                        color="primary"
                      >
                        Editar
                      </v-btn>
                      <v-btn
                        v-show="event.status==0"
                        @click="cancelSchedule(event)"
                        flat
                        color="secondary"
                      >
                        Cancelar cita
                      </v-btn>

                    </v-card-actions>
                  </v-card>
                </v-menu>
              </template>
            </template>
          </v-calendar>
        </v-sheet>
      </v-flex>
    </v-container>
  </v-layout>
</template>
<script>


    import Form from 'vform';
    import axios from 'axios'
    import formatHour from "../../libs/filter"
    import XLSX from 'xlsx';

    export default {
        min:'',
        data: () => ({
            menu: false,
            menu2: false,
            menu3: false,
            menu4: false,
            dialogEdit: false,
            dataExcel: [],
            loadingTable: false,
            headers: [
                { text: 'Fecha inicio', align: 'center', value: 'fecha_inicial' },
                { text: 'Hora inicio', align: 'center', value: 'hora_inicial' },
                { text: 'Fecha fin', align: 'center', value: 'fecha_final' },
                { text: 'Hora fin', align: 'center', value: 'hora_final' },
                { text: 'Estado', align: 'center', value: 'status' },
            ],
            search: '',
            taker: 'Tomador: ',
            errorSchedule: false,
            start: '',
            quoteData: {
                description:''
            },
            name: "create",
            validated: {
                message: '',
                error: false
            },

            data: new Form({
            }),
            dialog: false,
            date_init: 'Hora inicial: ',
            date_end: 'Hora final: ',
            today: Date.now(),
            events: [],
            monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
              "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
            ],
            month_to_show: '',
        }),
        computed: {
            // convert the list of events into a map of lists keyed by date
            eventsMap () {
                const map = {}
                this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
                return map
            }
        },
        methods: {
            cancelSchedule(item){
                axios.post('/api/schedule/cancel',{id:item.id})
                    .then(resp=>{
                        if (resp.data.length<1){
                            this.dateAll()
                            this.$store.dispatch('responseMessage', {
                                type: 'success',
                                text: this.$t('Una de las personas no tiene correo electronico, por favor notifique por otro medio'),
                                title: this.$t('event.create-form.stored-ok-title'),
                                modal: true
                            })
                        }else {
                            this.dateAll()
                            this.$store.dispatch('responseMessage', {
                                type: 'success',
                                text: this.$t('Cita cancelada con éxito'),
                                title: this.$t('event.create-form.stored-ok-title'),
                                modal: true
                            })}

                    }).catch(erro=>{

                })

            },
            getEdit(item){
                this.data.id = item.id
                this.data.dateStart = item.date
                this.data.dateEnd = item.end_date
                this.dialogEdit = true
                this.dialog = false
                this.data.details= item.details
                this.data.timeStart= item.start
                this.data.open= item.open
                this.data.timeEnd= item.end
                this.data.status= 0
                this.data.taker=item.taker
                this.data.title= item.title
                this.quoteData.responsible_appointment_id
                //this.validateData()

            },
            ExcelToJSON ()  {
                this.parseExcel = (file)=> {
                    let reader = new FileReader();

                    reader.onload = (e)=> {
                        let data = e.target.result;
                        let workbook = XLSX.read(data, {
                            type: 'binary'
                        });
                        workbook.SheetNames.forEach(function(sheetName) {
                            // Here is your object
                            let XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                            let json_object = JSON.stringify(XL_row_object);
                            localStorage.setItem("dataExcelSchedule", JSON.stringify(XL_row_object));
                        })
                    };
                    reader.onerror = function(ex) {
                        console.log(ex);
                    };

                    reader.readAsBinaryString(file);
                };
            },
            handleFileSelect(evt) {
                var files = evt.target.files; // FileList object;
                var xl2json = new this.ExcelToJSON();
                xl2json.parseExcel(files[0]);
                setTimeout(() => {
                    this.getUpLoaFile()
                }, 1500);
            },
            upFile() {
                localStorage.removeItem("dataExcelSchedule");
                document.getElementById('upload').addEventListener('change', this.handleFileSelect, false);
            },
            getUpLoaFile(){
                this.dataExcel = JSON.parse(localStorage.getItem("dataExcelSchedule")).map(obj=>{
                    return {
                        fecha_inicial : obj.fecha_inicial,
                        hora_inicial : obj.hora_inicial + ':00.0000000',
                        fecha_final : obj.fecha_final,
                        hora_final : obj.hora_final + ':00.0000000',
                        status : 0,
                        responsible_appointment_id: this.quoteData.responsible_appointment_id,

                    }
                });

            },
            proccess(){

                axios.post("/api/schedule/validate/wizard", this.dataExcel)
                    .then(resp=>{
                        this.dataExcel = resp.data.data
                        this.dateAll()

                    }).catch(error=>{
                })
            },
            getDay () {
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0!

                var yyyy = today.getFullYear();

                this.start =  yyyy + '-' + mm + '-' + dd;
            },
            nextPrev (num) {
                // let date = '2019-06-06'
                let fecha_split = this.start.split('-');
                let month = (parseInt(fecha_split[1]) + num)
                let nueva_fecha = fecha_split[0] + "-" + month + "-" + fecha_split[2];
                this.start = nueva_fecha;
                //this.start = this.start.setMonth(this.start.getMonth() + 3)
            },
            async create() {
                let data = {
                    'responsible_appointment_id': this.quoteData.responsible_appointment_id,
                    'schedule_start_date': this.data.dateStart,
                    'schedule_start_time': this.data.timeStart,
                    'schedule_end_date': this.data.dateEnd,
                    'schedule_end_time': this.data.timeEnd
                }
                if (await this.formHasErrors()) return
                axios.post('/api/schedule', data).then(resp=>{
                    this.dateAll();
                    this.dialog = false;
                    this.dataExcel = []
                    this.errorSchedule = false
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: this.$t('Cita creada con éxito'),
                        title: this.$t('event.create-form.stored-ok-title'),
                        modal: true
                    })
                }).catch(error=>{
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: this.$t('Se presento un error al crear la cita, intente de nuevo'),
                        title: this.$t('event.create-form.stored-ok-title'),
                        modal: true
                    })
                })
            },
            async update() {
                let data = {
                    'id': this.data.id,
                    'responsible_appointment_id': this.quoteData.responsible_appointment_id,
                    'schedule_start_date': this.data.dateStart,
                    'schedule_start_time': this.data.timeStart + ':00.0000000',
                    'schedule_end_date': this.data.dateEnd,
                    'schedule_end_time': this.data.timeEnd + ':00.0000000'
                }
                if (await this.formHasErrors()) return
                axios.post('/api/schedule/update', data).then(resp=>{
                    this.dateAll();
                    this.dialog = false;
                    this.dialogEdit = false;
                    this.dataExcel = []
                    this.errorSchedule = false
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: this.$t('Cita creada con éxito'),
                        title: this.$t('event.create-form.stored-ok-title'),
                        modal: true
                    })
                }).catch(error=>{
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: this.$t('Se presento un error al crear la cita, intente de nuevo'),
                        title: this.$t('event.create-form.stored-ok-title'),
                        modal: true
                    })
                })
            },
            dateAll(idQuote) {
                this.getDay();
                axios.get('/api/schedule/show/' + this.$route.params.id).then(resp=>{
                    this.events = resp.data.data.map(obj=>{
                        return {
                            id: obj.id,
                            end_date: obj.schedule_end_date,
                            date: obj.schedule_start_date,
                            open: false,
                            title: formatHour(obj.schedule_start_time),
                            details: '',
                            start: formatHour(obj.schedule_start_time),
                            end: formatHour(obj.schedule_end_time),
                            status: obj.status,
                            taker: obj.name
                        }
                    })
                });
            },
            PrevCanlendar () {
                this.dialog = false;
                this.errorSchedule = false;
            },
            open (event) {
            },
            async getQuotes(){
                axios.get('/api/qoutes/get/' + this.$route.params.id).then(resp=>{
                    this.quoteData = resp.data.data
                    this.dateAll(this.$route.params.id);
                }).catch(error=>{

                });
            },
            async validateData () {
                if (this.data.dateStart == undefined || this.data.timeStart == undefined || this.data.dateEnd == undefined || this.data.timeEnd== undefined){
                    this.errorSchedule = true;
                    this.validated.message = 'Diligencie todos los campos marcados con *'
                    return
                }
                if (this.data.dateStart > this.data.dateEnd || this.data.timeStart > this.data.timeEnd) {
                    this.errorSchedule = true
                    this.validated.message = 'La fecha y hora final no pueden ser menor que la fecha y hora inicial'
                    return

                }
                let data = {
                    'responsible_appointment_id': this.quoteData.responsible_appointment_id,
                    'schedule_start_date': this.data.dateStart,
                    'schedule_start_time': this.data.timeStart + ':00.0000000',
                    'schedule_end_date': this.data.dateEnd,
                    'schedule_end_time': this.data.timeEnd + ':00.0000000'
                }
                axios.post("/api/schedule/validate", data)
                    .then(resp=>{
                        if (resp.data.data.length > 0){
                            this.errorSchedule = true;
                            this.validated.message = 'Ya existe una agenda entre las fechas y las horas seleccionadas'
                        }else {

                            this.errorSchedule = false;
                        }

                    }).catch(error=>{
                })
            }
        },
        created() {
            this.getQuotes();
            this.dateAll();
        },
        watch: {
            "data.timeStart": function (val) {
                this.validateData()
            },
            "data.dateStart": function (val) {
                this.validateData()
            },
            "data.dateEnd": function (val) {
                this.validateData()
            },
            "data.timeEnd": function (val) {
                this.validateData()
            },
            start(newValue) {
              const month = newValue.split('-')
              if (month.length > 2) {
                const montNumber = parseInt(month[1], 10)
                this.month_to_show = this.monthNames[montNumber-1]
                return
              }
              this.month_to_show = ''
            }
        }
    }
</script>

<style lang='scss'>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
  .my-event-process {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #c0ba2f;
    color: #ffffff;
    border: 1px solid #c0ba2f;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
  .my-event-success {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #6dc075;
    color: #ffffff;
    border: 1px solid #6dc075;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/shedule/create.vue